// I18N_START
const TRANSLATIONS = {
  en: {
    level:      "Level {n}",
    level_done: "Level Complete!",
    next_level: "Next Level →",
    restart:    "↺",
    resume:     "Resume",
    tap_to_start: "Tap to start",
    to_hub:     "Home",
    undo:       "↩",
    you_win:    "You Win!",
    play_again: "Play Again",
    hook_ws_lastpour: "One pour to finish!",
    hook_ws_almost: "Two moves from done",
    hook_ws_midgame: "Sort it out",
    hook_play: "Play",
    cta_win_title: "Solved! 🎉",
    cta_install: "Add to home screen",
    cta_again: "Play again",
  },
  hi: {
    level:      "स्तर {n}",
    level_done: "स्तर पूरा!",
    next_level: "अगला स्तर →",
    restart:    "↺",
    resume:     "जारी रखें",
    tap_to_start: "शुरू करने के लिए टैप करें",
    to_hub:     "मुख्य",
    undo:       "↩",
    you_win:    "आप जीते!",
    play_again: "फिर खेलें",
    hook_ws_lastpour: "बस एक डालना बाकी!",
    hook_ws_almost: "दो चालों में पूरा",
    hook_ws_midgame: "इसे सुलझाएँ",
    hook_play: "खेलें",
    cta_win_title: "हल हो गया! 🎉",
    cta_install: "होम स्क्रीन पर जोड़ें",
    cta_again: "फिर से खेलें",
  },
  ru: {
    level:      "Уровень {n}",
    level_done: "Уровень пройден!",
    next_level: "Дальше →",
    restart:    "↺",
    resume:     "Продолжить",
    tap_to_start: "Нажмите чтобы начать",
    to_hub:     "В хаб",
    undo:       "↩",
    you_win:    "Победа!",
    play_again: "Ещё раз",
    hook_ws_lastpour: "Один перелив до конца!",
    hook_ws_almost: "Два хода до победы",
    hook_ws_midgame: "Разбери по цветам",
    hook_play: "Играть",
    cta_win_title: "Собрано! 🎉",
    cta_install: "Добавить на экран",
    cta_again: "Ещё разок",
  },
} as const;
// I18N_END

type Lang   = keyof typeof TRANSLATIONS;
type Key    = keyof typeof TRANSLATIONS['ru'];
type Params = Record<string, string | number>;

const _lang = (localStorage.getItem('lang') ?? navigator.language.slice(0, 2)) as Lang;
const _L    = TRANSLATIONS[_lang in TRANSLATIONS ? _lang : 'ru'];

export function t(key: Key, params?: Params): string {
  let s: string = _L[key] ?? TRANSLATIONS['ru'][key];
  if (params) for (const k in params) s = s.replace(`{${k}}`, String(params[k]));
  return s;
}
